import {appConfigService} from '_app/services';
import {stringify} from 'query-string';

const getUrl = options => {
	return `${appConfigService.get('serverPath')}api/v1/pdfBranding?${stringify(options)}`;
};

export default {
	getUrl
};